import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Landing from './pages/Landing';
import Result from './pages/Result';
import Feedback from './pages/Feedback';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import MyPage from './pages/MyPage';
import DecemberFortune from './pages/DecemberFortune';
import DecemberFortuneResult from './pages/DecemberFortuneResult';
import ShareFortuneResult from './pages/ShareFortuneResult';
import NewYearFortune2026 from './pages/NewYearFortune2026';
import NewYearFortuneResult2026 from './pages/NewYearFortuneResult2026';
import ShareNewYearResult2026 from './pages/ShareNewYearResult2026';
import InstagramCallback from './components/admin/InstagramCallback';
import DynamicFortune from './pages/DynamicFortune';
import DynamicFortuneResultPage from './pages/DynamicFortuneResultPage';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/mind-reading" element={<Landing />} />
            <Route path="/landing" element={<Navigate to="/mind-reading" replace />} />
            <Route path="/result/:landingUserId" element={<Result />} />
            <Route path="/mind-reading-result/:mindReadingId" element={<Result />} />
            <Route path="/feedback/:landingUserId" element={<Feedback />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/instagram/callback" element={<InstagramCallback />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/december-fortune" element={<DecemberFortune />} />
            <Route path="/december-fortune-result/:fortuneId" element={<DecemberFortuneResult />} />
            <Route path="/newyear-fortune-2026" element={<NewYearFortune2026 />} />
            <Route path="/newyear-fortune-2026-result/:fortuneId" element={<NewYearFortuneResult2026 />} />
            <Route path="/share/:shareId" element={<ShareFortuneResult />} />
            <Route path="/share-newyear-2026/:shareId" element={<ShareNewYearResult2026 />} />

            {/* 동적 운세 라우팅 */}
            <Route path="/fortune/:templateKey" element={<DynamicFortune />} />
            <Route path="/fortune/:templateKey/result" element={<DynamicFortuneResultPage />} />
            <Route path="/fortune/:templateKey/result/:sessionId" element={<DynamicFortuneResultPage />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" />
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;